import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import FavReducer from "./FavReducer";
import UserReducer from "./UserReducer";
import PageReducer from "./PageReducer";
import PostReducer from "./PostReducer";
import ChatReducer from "./ChatReducer";
import HomeReducer from "./HomeReducer";
import ErrorReducer from "./ErrorReducer";
import CardsReducer from "./CardsReducer";
import ModalReducer from "./ModalReducer";
import ThemeReducer from "./ThemeReducer";
import FollowReducer from "./FollowReducer";
import PayoutReducer from "./PayoutReducer";
import SearchReducer from "./SearchReducer";
import WalletReducer from "./WalletReducer";
import SendTipReducer from "./SendTipReducer";
import CountryReducer from "./CountryReducer";
import StoriesReducer from "./StoriesReducer";
import notifyReducer from "react-redux-notify";
import WithDrawReducer from "./WithDrawReducer";
import CommentsReducer from "./CommentsReducer";
import BookmarkReducer from "./BookmarkReducer";
import OtherUserReducer from "./OtherUserReducer";
import PostLikesReducer from "./PostLikesReducer";
import BankAccountReducer from "./BankAccountReducer";
import KycDocumentReducer from "./KycDocumentReducer";
import TransactionReducer from "./TransactionReducer";
import NotificationReducer from "./NotificationReducer";
import SubscriptionReducer from "./SubscriptionReducer";
import ProductOwnerReducer from "./ProductOwnerReducer";
import LiveStreamingReducer from "./LiveStreamingReducer";
import SiteStatisticReducer from "./SiteStatisticReducer";
import ChangePasswordReducer from "./ChangePasswordReducer";
import UserConfigurationsReducer from "./UserConfigurationsReducer";
import SubscriptionPaymentReducer from "./SubscriptionPaymentReducer";
import VerificationDocumentReducer from "./VerificationDocumentReducer";
import ComponentReducer from "./ComponentReducer";
import Face2FacePaymentReducer from "./Face2FacePaymentReducer"
import Face2Fac2ePackageReducer from "./Face2Fac2ePackageReducer";
import Face2FaceSessionReduer from "./Face2FaceSessionReduer"
import F2FReducer from "./F2FReducer";
import ShowCaseReducer from "./ShowcaseReducer";
import AdsReducer from "./AdsReducer";
import ReferralReducer from "./ReferralReducer";
import TrackingLinkReducer from "./TrackingLinkReducer";
import VideoStoreReducer from "./VideoStoreReducer";

const PersistConfig = {
  key: "root",
  storage,
  whitelist: [],
};

const RootReducer = persistReducer(
  PersistConfig,
  combineReducers({
      f2f: F2FReducer,
      Session:Face2FaceSessionReduer,
      Package:Face2Fac2ePackageReducer,
      f2fPayment: Face2FacePaymentReducer,
      fav: FavReducer,
      chat: ChatReducer,
      home: HomeReducer,
      page: PageReducer,
      post: PostReducer,
      users: UserReducer,
      cards: CardsReducer,
      tip: SendTipReducer,
      theme: ThemeReducer,
      modals: ModalReducer,
      wallet: WalletReducer,
      search: SearchReducer,
      follow: FollowReducer,
      stories: StoriesReducer,
      comment: CommentsReducer,
      bookmark: BookmarkReducer,
      withDraw: WithDrawReducer,
      errorDetails: ErrorReducer,
      postLike: PostLikesReducer,
      payoutModel: PayoutReducer,
      otherUser: OtherUserReducer,
      countryModel: CountryReducer,
      notifications: notifyReducer,
      proOwner: ProductOwnerReducer,
      bankAccount: BankAccountReducer,
      kycDocument: KycDocumentReducer,
      transaction: TransactionReducer,
      siteStats: SiteStatisticReducer,
      docs: VerificationDocumentReducer,
      notification: NotificationReducer,
      subscriptions: SubscriptionReducer,
      liveStreaming: LiveStreamingReducer,
      changePassword: ChangePasswordReducer,
      userConfigurations: UserConfigurationsReducer,
      subscriptionsPayment: SubscriptionPaymentReducer,
      component: ComponentReducer,
      showCase:ShowCaseReducer,
      ads:AdsReducer,
      referral: ReferralReducer,
      trackingLinks:TrackingLinkReducer,
      videoStore: VideoStoreReducer,
    })
);

export default RootReducer;
